import { __assign, __awaiter, __rest, __generator } from '../../../_virtual/_tslib.js';
import { EXLY_COMMUNITY_FEED_TYPES } from '../../../constants/BrandedCommunity/Miscellaneous.js';
import { POST_TYPE_IDS_ENUM } from '../../../constants/BrandedCommunity/Post.js';

var usePostArgsAdapter = function (_a) {
    var 
    // props passed directly
    data = _a.data, userUuid = _a.userUuid, isCreator = _a.isCreator, creatorUuid = _a.creatorUuid, disablePostEdit = _a.disablePostEdit, disablePostDelete = _a.disablePostDelete, votingDisabled = _a.votingDisabled, channelUuid = _a.channelUuid, onUpdateSuccess = _a.onUpdateSuccess, onDeleteSuccess = _a.onDeleteSuccess, onPinToggleSuccess = _a.onPinToggleSuccess, notifySuccess = _a.notifySuccess, notifyError = _a.notifyError, onMemberClick = _a.onMemberClick, onPostOfferingBuyNowClick = _a.onPostOfferingBuyNowClick, errorLogger = _a.errorLogger, notify = _a.notify, votersFetcher = _a.votersFetcher, 
    // props processed/used by adapter
    brandedCommunityUuid = _a.brandedCommunityUuid, isChannel = _a.isChannel, callLikePostApi = _a.callLikePostApi, callLikeChannelPostApi = _a.callLikeChannelPostApi, callGetPostLikedByMembersListApi = _a.callGetPostLikedByMembersListApi, callGetChannelPostLikedByMembersListApi = _a.callGetChannelPostLikedByMembersListApi, callPinPostApi = _a.callPinPostApi, callPinChannelPostApi = _a.callPinChannelPostApi, callSubmitPostCommentApi = _a.callSubmitPostCommentApi, callSubmitChannelPostCommentApi = _a.callSubmitChannelPostCommentApi, callGetPostCommentsApi = _a.callGetPostCommentsApi, callGetChannelPostCommentsApi = _a.callGetChannelPostCommentsApi, callLikePostCommentApi = _a.callLikePostCommentApi, callLikeChannelPostCommentApi = _a.callLikeChannelPostCommentApi, callGetPostCommentLikedByMembersListApi = _a.callGetPostCommentLikedByMembersListApi, callGetChannelPostCommentLikedByMembersListApi = _a.callGetChannelPostCommentLikedByMembersListApi, callEditPostCommentApi = _a.callEditPostCommentApi, callEditChannelPostCommentApi = _a.callEditChannelPostCommentApi, callDeletePostCommentApi = _a.callDeletePostCommentApi, callDeleteChannelPostCommentApi = _a.callDeleteChannelPostCommentApi, callGetPostCommentRepliesApi = _a.callGetPostCommentRepliesApi, callGetChannelPostCommentRepliesApi = _a.callGetChannelPostCommentRepliesApi, callGetPreviewLinks = _a.callGetPreviewLinks, callCastVote = _a.callCastVote, callGetPostShareLink = _a.callGetPostShareLink;
    var commonRetrun = {
        data: data,
        userUuid: userUuid,
        creatorUuid: creatorUuid,
        disablePostEdit: disablePostEdit,
        disablePostDelete: disablePostDelete,
        isCreator: isCreator,
        votingDisabled: votingDisabled,
        canViewVoters: data.post_type === POST_TYPE_IDS_ENUM.POLL,
        errorLogger: errorLogger,
        notify: notify,
        votersFetcher: votersFetcher,
        onUpdateSuccess: onUpdateSuccess,
        onDeleteSuccess: onDeleteSuccess,
        onPinToggleSuccess: onPinToggleSuccess,
        notifySuccess: notifySuccess,
        notifyError: notifyError,
        onMemberClick: onMemberClick,
        onPostOfferingBuyNowClick: onPostOfferingBuyNowClick,
        callGetPreviewLinks: callGetPreviewLinks,
        callCastVote: function (args) {
            return callCastVote(__assign(__assign({}, args), { community_listing_uuid: brandedCommunityUuid, community_channel_uuid: channelUuid, post_uuid: data.post_uuid }));
        },
        callGetPostShareLink: function () {
            return callGetPostShareLink({
                community_channel_uuid: channelUuid,
                post_uuid: data.post_uuid,
                exly_feed_type: isChannel
                    ? EXLY_COMMUNITY_FEED_TYPES.COMMUNITY_CHANNEL
                    : EXLY_COMMUNITY_FEED_TYPES.COMMUNITY,
                community_listing_uuid: brandedCommunityUuid,
            });
        },
        isChannel: isChannel,
    };
    if (isChannel) {
        return __assign(__assign({}, commonRetrun), { callLikeApi: function (_a) {
                var post_uuid = _a.post_uuid;
                return callLikeChannelPostApi({
                    community_listing_uuid: brandedCommunityUuid,
                    channel_post_uuid: post_uuid,
                });
            }, callGetLikedByMembersListApi: function (args) { return __awaiter(void 0, void 0, void 0, function () {
                var response, _a, responseData, remainingResponse;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, callGetChannelPostLikedByMembersListApi(__assign({ community_listing_uuid: brandedCommunityUuid }, args))];
                        case 1:
                            response = _b.sent();
                            _a = response.data, responseData = _a === void 0 ? {} : _a, remainingResponse = __rest(response, ["data"]);
                            return [2 /*return*/, __assign(__assign({}, remainingResponse), { data: {
                                        members: responseData.feed_channel_post_reaction_users_list,
                                        total: responseData.total,
                                        total_pages: responseData.total_pages,
                                    } })];
                    }
                });
            }); }, callPinApi: callPinChannelPostApi
                ? function (args) {
                    return callPinChannelPostApi(__assign({ community_listing_uuid: brandedCommunityUuid }, args));
                }
                : undefined, callSubmitPostCommentApi: function (args) {
                return callSubmitChannelPostCommentApi(__assign({ community_listing_uuid: brandedCommunityUuid }, args));
            }, callGetPostCommentsApi: function (args) { return __awaiter(void 0, void 0, void 0, function () {
                var response, _a, responseData, remainingResponse;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, callGetChannelPostCommentsApi(__assign({ community_listing_uuid: brandedCommunityUuid }, args))];
                        case 1:
                            response = (_b.sent()) || {};
                            _a = response.data, responseData = _a === void 0 ? {} : _a, remainingResponse = __rest(response, ["data"]);
                            return [2 /*return*/, __assign(__assign({}, remainingResponse), { data: {
                                        comments: responseData.channel_post_comments,
                                        total: responseData.total,
                                        total_pages: responseData.total_pages,
                                    } })];
                    }
                });
            }); }, callLikePostCommentApi: function (_a) {
                var comment_uuid = _a.comment_uuid, args = __rest(_a, ["comment_uuid"]);
                return callLikeChannelPostCommentApi(__assign({ community_listing_uuid: brandedCommunityUuid, channel_post_comment_uuid: comment_uuid }, args));
            }, callGetPostCommentLikedByMembersListApi: function (args) { return __awaiter(void 0, void 0, void 0, function () {
                var response, _a, responseData, remainingResponse;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, callGetChannelPostCommentLikedByMembersListApi(__assign({ community_listing_uuid: brandedCommunityUuid }, args))];
                        case 1:
                            response = _b.sent();
                            _a = response.data, responseData = _a === void 0 ? {} : _a, remainingResponse = __rest(response, ["data"]);
                            return [2 /*return*/, __assign(__assign({}, remainingResponse), { data: {
                                        members: responseData.feed_channel_post_comment_reaction_users_list,
                                        total: responseData.total,
                                        total_pages: responseData.total_pages,
                                    } })];
                    }
                });
            }); }, callEditPostCommentApi: function (args) {
                return callEditChannelPostCommentApi(__assign({ community_listing_uuid: brandedCommunityUuid }, args));
            }, callDeletePostCommentApi: function (args) {
                return callDeleteChannelPostCommentApi(__assign({ community_listing_uuid: brandedCommunityUuid }, args));
            }, callGetPostCommentRepliesApi: function (args) { return __awaiter(void 0, void 0, void 0, function () {
                var response, _a, responseData, remainingResponse;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, callGetChannelPostCommentRepliesApi(__assign({ community_listing_uuid: brandedCommunityUuid }, args))];
                        case 1:
                            response = (_b.sent()) || {};
                            _a = response.data, responseData = _a === void 0 ? {} : _a, remainingResponse = __rest(response, ["data"]);
                            return [2 /*return*/, __assign(__assign({}, remainingResponse), { data: {
                                        comments: responseData.channel_post_comment_replies,
                                        total: responseData.total,
                                        total_pages: responseData.total_pages,
                                    } })];
                    }
                });
            }); } });
    }
    return __assign(__assign({}, commonRetrun), { callLikeApi: function (args) {
            return callLikePostApi(__assign({ community_listing_uuid: brandedCommunityUuid }, args));
        }, callGetLikedByMembersListApi: function (args) { return __awaiter(void 0, void 0, void 0, function () {
            var response, _a, responseData, remainingResponse;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, callGetPostLikedByMembersListApi(__assign({ community_listing_uuid: brandedCommunityUuid }, args))];
                    case 1:
                        response = _b.sent();
                        _a = response.data, responseData = _a === void 0 ? {} : _a, remainingResponse = __rest(response, ["data"]);
                        return [2 /*return*/, __assign(__assign({}, remainingResponse), { data: {
                                    members: responseData.community_post_users_liked_list,
                                    total: responseData.total,
                                    total_pages: responseData.total_pages,
                                } })];
                }
            });
        }); }, callPinApi: callPinPostApi
            ? function (args) {
                return callPinPostApi(__assign({ community_listing_uuid: brandedCommunityUuid }, args));
            }
            : undefined, callSubmitPostCommentApi: function (args) {
            return callSubmitPostCommentApi(__assign({ community_listing_uuid: brandedCommunityUuid }, args));
        }, callGetPostCommentsApi: function (args) { return __awaiter(void 0, void 0, void 0, function () {
            var response, _a, responseData, remainingResponse;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, callGetPostCommentsApi(__assign({ community_listing_uuid: brandedCommunityUuid }, args))];
                    case 1:
                        response = (_b.sent()) || {};
                        _a = response.data, responseData = _a === void 0 ? {} : _a, remainingResponse = __rest(response, ["data"]);
                        return [2 /*return*/, __assign(__assign({}, remainingResponse), { data: {
                                    comments: responseData.community_post_comments,
                                    total: responseData.total,
                                    total_pages: responseData.total_pages,
                                } })];
                }
            });
        }); }, callLikePostCommentApi: function (args) {
            return callLikePostCommentApi(__assign({ community_listing_uuid: brandedCommunityUuid }, args));
        }, callGetPostCommentLikedByMembersListApi: function (args) { return __awaiter(void 0, void 0, void 0, function () {
            var response, _a, responseData, remainingResponse;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, callGetPostCommentLikedByMembersListApi(__assign({ community_listing_uuid: brandedCommunityUuid }, args))];
                    case 1:
                        response = _b.sent();
                        _a = response.data, responseData = _a === void 0 ? {} : _a, remainingResponse = __rest(response, ["data"]);
                        return [2 /*return*/, __assign(__assign({}, remainingResponse), { data: {
                                    members: responseData.community_post_comment_reaction_users_list,
                                    total: responseData.total,
                                    total_pages: responseData.total_pages,
                                } })];
                }
            });
        }); }, callEditPostCommentApi: function (args) {
            return callEditPostCommentApi(__assign({ community_listing_uuid: brandedCommunityUuid }, args));
        }, callDeletePostCommentApi: function (args) {
            return callDeletePostCommentApi(__assign({ community_listing_uuid: brandedCommunityUuid }, args));
        }, callGetPostCommentRepliesApi: function (args) { return __awaiter(void 0, void 0, void 0, function () {
            var response, _a, responseData, remainingResponse;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, callGetPostCommentRepliesApi(__assign({ community_listing_uuid: brandedCommunityUuid }, args))];
                    case 1:
                        response = (_b.sent()) || {};
                        _a = response.data, responseData = _a === void 0 ? {} : _a, remainingResponse = __rest(response, ["data"]);
                        return [2 /*return*/, __assign(__assign({}, remainingResponse), { data: {
                                    comments: responseData.community_post_comment_replies,
                                    total: responseData.total,
                                    total_pages: responseData.total_pages,
                                } })];
                }
            });
        }); } });
};

export { usePostArgsAdapter };
//# sourceMappingURL=usePostArgsAdapter.js.map
